import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function formatNumber(n: number): string {
  return new Intl.NumberFormat('hu-HU').format(n);
}

export function formatDate(iso: string | Date | null | undefined): string {
  if (!iso) return '—';
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  return d.toLocaleString('hu-HU', { dateStyle: 'short', timeStyle: 'short' });
}

// Format a Date as the local wall-clock string an <input type="datetime-local">
// expects (`yyyy-MM-ddTHH:mm`, no timezone, no seconds).
export function toDatetimeLocal(d: Date): string {
  const local = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 16);
}

// Default diagnostics date range: from one month ago to now.
export function defaultDateRange(): { from: string; to: string } {
  const to = new Date();
  const from = new Date(to);
  from.setMonth(from.getMonth() - 1);
  return { from: toDatetimeLocal(from), to: toDatetimeLocal(to) };
}
